import Vue from 'vue';
import VueRouter from 'vue-router';
import accountRoutes from './account';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  routes: accountRoutes,
});

router.afterEach((to) => {
  Vue.$gtm.trackEvent({
    'event': 'content-view',
    'content-name': to.fullPath,
    'content-view-name': to.name,
  });
});

export default router;
